export const HOST = process.env.REACT_APP_API_HOST;
export const API_URL = `${HOST}/api`;
export const AUTHROUTE = `${API_URL}/auth`;
export const LOGINROUTE = `${AUTHROUTE}/login`;
export const LOGOUTROUTE = `${AUTHROUTE}/logout`;
export const REGISTERROUTE = `${AUTHROUTE}/register`;
export const PASSWORDRECOVERYROUTE = `${AUTHROUTE}/password`;
export const CHANGEPASSWORDROUTE = `${AUTHROUTE}/change-password`;

export const USERSROUTE = `${API_URL}/users`;
export const BIKESROUTE = `${API_URL}/bikes`;
export const CLIENTSROUTE = `${API_URL}/clients`;
export const STATIONSROUTE = `${API_URL}/stations`;
export const BIKECODES_ROUTE = `${API_URL}/bikecodes`;
export const FAVORITESROUTE = `${API_URL}/favorites`;
export const DASHBOARDROUTE = `${API_URL}/dashboard`;
export const CATEGORIESROUTE = `${API_URL}/categories`;
export const RESERVATIONSROUTE = `${API_URL}/reservations`;
export const CLIENTRESERVATIONROUTE = `${API_URL}/clients/reservation`;
export const PAYMENTTYPESROUTE = `${API_URL}/payment-types`;
